import React from 'react';
import { PRICE, PRICE_PLN, SAVINGS, TOTAL_VALUE, valueStack } from '../data/valueStack';
import { CtaButton } from './CtaButton';
import { Eyebrow } from './Eyebrow';
export function FinalCall() {
  return <section aria-labelledby="final-heading" className="border-y border-night-600 bg-night-950 py-14 sm:py-24" data-id="element-108" data-mp="2ymrm9thxoaqv">
      <div className="mx-auto grid max-w-shell gap-10 px-5 sm:px-6 lg:grid-cols-2 lg:items-center lg:gap-20" data-id="element-109" data-mp="2tphpttw4mytj">
        <div data-id="element-110" data-mp="3rbopqqhhk2zk">
          <Eyebrow data-id="element-111" data-mp="3rbf93tibz86j">Podsumowanie</Eyebrow>
          <h2 id="final-heading" className="mt-4 font-display text-4xl leading-[0.98] text-cream sm:text-6xl" data-id="element-112" data-mp="3mddj0omhm8lk">
            Kompletny pakiet, <span className="text-amber" data-id="element-113" data-mp="3hcpr80qfpnqa">cena premierowa</span>
          </h2>
          <p className="mt-6 max-w-sm text-sm text-cream-muted" data-id="element-114" data-mp="3dcyw5ktvklfy">
            Jedna płatność, wszystkie materiały od razu na Twoim e-mailu i 10 dni na sprawdzenie ich
            na prawdziwych zajęciach.
          </p>
        </div>
        <div className="rounded-2xl border border-amber/50 bg-night-800 p-6 sm:p-10" data-id="element-115" data-mp="21vpaqsr6rjc0">
          <p className="text-xs font-semibold uppercase tracking-label text-amber sm:text-sm" data-id="element-116" data-mp="i5jq3jep0d46">
            Plan semestru + 6 tomów + 5 bonusów
          </p>
          <dl className="mt-5 border-y border-night-600 py-4" data-id="element-117" data-mp="93u1smg3xuam">
            {valueStack.map(line => <div key={line.label} className="flex items-baseline justify-between gap-4 py-1.5" data-id="element-118" data-mp="d55iu3kx1777">
                <dt className="text-xs text-cream-muted" data-id="element-119" data-mp="3vjokck2fwj8q">{line.label}</dt>
                <dd className="text-xs font-semibold tabular-nums text-cream-soft" data-id="element-120" data-mp="3vhbvdmy9l8m6">{line.value}</dd>
              </div>)}
            <div className="flex items-baseline justify-between gap-4 pt-2" data-id="element-121" data-mp="3llqw3wkkymg4">
              <dt className="text-[10px] font-semibold uppercase tracking-label text-cream-muted" data-id="element-122" data-mp="3qkblf0yanlps">
                Łączna realna wartość
              </dt>
              <dd className="text-xs font-semibold tabular-nums text-cream-muted line-through" data-id="element-123" data-mp="3clvjdnbdmjdz">{TOTAL_VALUE}</dd>
            </div>
          </dl>
          <p className="mt-5 flex items-baseline gap-3" data-id="element-124" data-mp="1n3f0dr9gk0j4">
            <span className="font-display text-6xl leading-none text-amber sm:text-7xl" data-id="element-125" data-mp="1n4zx9nj8vvk5">{PRICE}</span>
            <span className="font-display text-xl leading-none text-cream-muted line-through" data-id="element-126" data-mp="1ib5huwaoa2qv">{TOTAL_VALUE}</span>
          </p>
          <p className="mt-2 text-sm text-cream-soft" data-id="element-127" data-mp="1db9aqo6ohv73">{PRICE_PLN}</p>
          <p className="mt-3 text-sm font-semibold text-amber-light" data-id="element-128" data-mp="19dlcpc9ovmaz">Oszczędzasz dziś {SAVINGS}</p>
          <div className="mt-7" data-id="element-129" data-mp="261rc9krr7oie">
            <CtaButton size="lg" fullWidth data-id="element-130" data-mp="25zwyqritayoc">
              Tak, chcę to teraz
            </CtaButton>
          </div>
          <ul className="mt-6 space-y-1.5 text-xs text-cream-muted" data-id="element-131" data-mp="1x1cqkkavo7ed">
            <li data-id="element-132" data-mp="1x3pfjhf1zi0x">Płatność jednorazowa &middot; Bez subskrypcji</li>
            <li data-id="element-133" data-mp="1s1qa81zr6b1c">Natychmiastowy dostęp do wszystkich materiałów</li>
            <li data-id="element-134" data-mp="lmz49jvrw00g">10-dniowa gwarancja satysfakcji</li>
          </ul>
        </div>
      </div>
    </section>;
}